module.exports = __webpack_public_path__ + "img/diskimages.d0862902.jpg";